module.exports = __webpack_public_path__ + "media/mabani/mabani-slide2-dc4a963f.jpg";